/**
 * Ephemeral cross-lab handoff for "Animate this still" (A-F7) — the Phase-1
 * hero flow. Image Lab pushes a source still here, then navigates to
 * `/labs/animation-lab/motion`. Animation Lab's mount effect consumes (reads +
 * clears) it and pre-fills the Image→Video panel with the still as the canvas
 * poster.
 *
 * Single-slot, last-write-wins, not persisted — same posture as
 * [[sourceHandoffStore]] / captionHandoffStore.
 */

import { create } from 'zustand';

export interface AnimateHandoff {
  sourceAssetId: string;
  /** Signed playback/preview URL for the still (poster while rendering). */
  sourceSignedUrl?: string;
}

interface AnimateHandoffState {
  pending: AnimateHandoff | null;
  setHandoff: (handoff: AnimateHandoff) => void;
  consumeHandoff: () => AnimateHandoff | null;
  clearHandoff: () => void;
}

export const useAnimateHandoffStore = create<AnimateHandoffState>((set, get) => ({
  pending: null,
  setHandoff: handoff => set({ pending: handoff }),
  consumeHandoff: () => {
    const pending = get().pending;
    if (pending !== null) set({ pending: null });
    return pending;
  },
  clearHandoff: () => set({ pending: null }),
}));
